import React from 'react';
import PropTypes from 'prop-types';

import { SearchBox } from 'components/search/SearchBox';
import { StickySearchBar } from 'components/landing/StickySearchBar';
import './PSPSearchBar.scss';

export default function PSPSearchBar({ handleSearch, className }) {
	return (
		<>
			<div className={`psp-search-bar`}>
				<SearchBox
					id="psp-search-bar-sticky-search"
					inputLabel="Search by city or zip code"
					handleSearch={handleSearch}
					buttonText="Find Storage Near You"
					darkButton={true}
					className={className}
				/>
			</div>
			<StickySearchBar
				handleSearch={handleSearch}
				triggerId="psp-search-bar-sticky-search"
				className="sizeguide-variant"
				inputLabel="Search by city or zip code"
				buttonText="Find Storage Near You"
				darkButton
				hideTitle
			/>
		</>
	);
}

PSPSearchBar.propTypes = {
	handleSearch: PropTypes.func,
	className: PropTypes.string,
};
